(function () {
  // Prevent double-mount
  if (window.__BLOCK_CATCH_WIDGET_MOUNTED__) return;
  window.__BLOCK_CATCH_WIDGET_MOUNTED__ = true;

  function mount(container) {
    container.innerHTML = `
      <div class="bcw">
        <div class="bcw__header">
          <div>
            <div class="bcw__title">Block Catch</div>
            <div class="bcw__sub">Catch blocks. Miss 3 and it's over.</div>
          </div>
          <div class="bcw__stats">
            <span>Score: <b id="bcwScore">0</b></span>
            <span>Misses: <b id="bcwMisses">0</b>/3</span>
          </div>
        </div>

        <div class="bcw__game" aria-label="Block Catch game area">
          <canvas id="bcwCanvas" width="360" height="360"></canvas>

          <div class="bcw__overlay" id="bcwOverlay">
            <div class="bcw__overlayCard">
              <div class="bcw__overlayTitle" id="bcwOverlayTitle">Tap Start</div>
              <div class="bcw__overlayText" id="bcwOverlayText">Move the paddle to catch falling blocks.</div>
              <button class="bcw__btn" id="bcwStartBtn" type="button">Start</button>
            </div>
          </div>
        </div>

        <div class="bcw__controls">
          <button class="bcw__btn bcw__btn--ghost" id="bcwResetBtn" type="button">Reset</button>
          <div class="bcw__hint">Tip: drag/touch inside the game area, or use ← → on desktop.</div>
        </div>
      </div>
    `;

    // Styles injected (keeps install easy)
    const style = document.createElement("style");
    style.textContent = `
      .bcw{border:1px solid rgba(0,0,0,.12);border-radius:16px;padding:14px;max-width:520px;margin:0 auto;background:#fff}
      .bcw__header{display:flex;gap:12px;justify-content:space-between;align-items:flex-start;margin-bottom:10px}
      .bcw__title{font-size:18px;font-weight:700;line-height:1.1}
      .bcw__sub{font-size:12px;opacity:.75;margin-top:4px}
      .bcw__stats{display:flex;flex-direction:column;gap:4px;font-size:12px;opacity:.9;text-align:right}
      .bcw__game{position:relative;display:flex;justify-content:center;align-items:center}
      #bcwCanvas{width:min(360px, 92vw);height:auto;border-radius:14px;background:linear-gradient(180deg,#f6f7ff,#ffffff);border:1px solid rgba(0,0,0,.08);touch-action:none}
      .bcw__overlay{position:absolute;inset:0;display:flex;justify-content:center;align-items:center}
      .bcw__overlayCard{background:rgba(255,255,255,.92);backdrop-filter:blur(6px);border:1px solid rgba(0,0,0,.12);border-radius:14px;padding:14px;max-width:320px;text-align:center;box-shadow:0 12px 30px rgba(0,0,0,.08)}
      .bcw__overlayTitle{font-size:16px;font-weight:800;margin-bottom:6px}
      .bcw__overlayText{font-size:12px;opacity:.78;margin-bottom:10px}
      .bcw__controls{display:flex;gap:10px;align-items:center;justify-content:space-between;margin-top:10px;flex-wrap:wrap}
      .bcw__hint{font-size:12px;opacity:.7;flex:1;min-width:200px}
      .bcw__btn{appearance:none;border:0;border-radius:999px;padding:10px 14px;font-weight:700;cursor:pointer;background:#111;color:#fff}
      .bcw__btn--ghost{background:transparent;color:#111;border:1px solid rgba(0,0,0,.18)}
      .bcw__btn:active{transform:translateY(1px)}
    `;
    container.appendChild(style);

    const canvas = container.querySelector("#bcwCanvas");
    const ctx = canvas.getContext("2d");

    const scoreEl = container.querySelector("#bcwScore");
    const missesEl = container.querySelector("#bcwMisses");
    const overlay = container.querySelector("#bcwOverlay");
    const overlayTitle = container.querySelector("#bcwOverlayTitle");
    const overlayText = container.querySelector("#bcwOverlayText");
    const startBtn = container.querySelector("#bcwStartBtn");
    const resetBtn = container.querySelector("#bcwResetBtn");

    // Game state
    let running = false;
    let score = 0;
    let misses = 0;

    const W = canvas.width;
    const H = canvas.height;

    // Paddle
    const paddle = { w: 90, h: 12, x: (W - 90) / 2, y: H - 28, vx: 0 };

    // Blocks
    let blocks = [];
    let spawnTimer = 0;
    let spawnEvery = 45; // frames; decreases as score increases

    function reset() {
      running = false;
      score = 0;
      misses = 0;
      blocks = [];
      spawnTimer = 0;
      spawnEvery = 45;
      paddle.x = (W - paddle.w) / 2;
      paddle.vx = 0;
      updateUI();
      showOverlay("Tap Start", "Move the paddle to catch falling blocks.");
      draw();
    }

    function updateUI() {
      scoreEl.textContent = String(score);
      missesEl.textContent = String(misses);
    }

    function showOverlay(title, text) {
      overlayTitle.textContent = title;
      overlayText.textContent = text;
      overlay.style.display = "flex";
    }

    function hideOverlay() {
      overlay.style.display = "none";
    }

    function spawnBlock() {
      const size = 18 + Math.random() * 10;
      const x = Math.random() * (W - size);
      const speed = 2.2 + Math.min(3, score / 25);
      blocks.push({ x, y: -size, s: size, vy: speed });
    }

    function clamp(val, min, max) {
      return Math.max(min, Math.min(max, val));
    }

    // Input: pointer drag inside canvas
    function pointerMove(clientX) {
      const rect = canvas.getBoundingClientRect();
      const x = ((clientX - rect.left) / rect.width) * W;
      paddle.x = clamp(x - paddle.w / 2, 0, W - paddle.w);
    }

    canvas.addEventListener("pointerdown", (e) => {
      canvas.setPointerCapture(e.pointerId);
      pointerMove(e.clientX);
    });
    canvas.addEventListener("pointermove", (e) => {
      if (e.buttons) pointerMove(e.clientX);
    });

    // Keyboard
    window.addEventListener("keydown", (e) => {
      if (e.key === "ArrowLeft") paddle.vx = -6;
      if (e.key === "ArrowRight") paddle.vx = 6;
      if (e.key === " " && !running) start();
    });
    window.addEventListener("keyup", (e) => {
      if (e.key === "ArrowLeft" || e.key === "ArrowRight") paddle.vx = 0;
    });

    function start() {
      running = true;
      hideOverlay();
    }

    startBtn.addEventListener("click", start);
    resetBtn.addEventListener("click", reset);

    function step() {
      if (!running) return;

      // Paddle movement (keyboard)
      paddle.x = clamp(paddle.x + paddle.vx, 0, W - paddle.w);

      // Spawn blocks
      spawnTimer++;
      const dynamicSpawn = Math.max(18, spawnEvery - Math.floor(score / 8));
      if (spawnTimer >= dynamicSpawn) {
        spawnTimer = 0;
        spawnBlock();
      }

      // Update blocks
      for (let i = blocks.length - 1; i >= 0; i--) {
        const b = blocks[i];
        b.y += b.vy;

        // Collision with paddle
        const hit =
          b.x < paddle.x + paddle.w &&
          b.x + b.s > paddle.x &&
          b.y < paddle.y + paddle.h &&
          b.y + b.s > paddle.y;

        if (hit) {
          blocks.splice(i, 1);
          score += 1;
          updateUI();
          continue;
        }

        // Missed
        if (b.y > H + b.s) {
          blocks.splice(i, 1);
          misses += 1;
          updateUI();
          if (misses >= 3) {
            running = false;
            showOverlay("Game Over", `Final score: ${score}. Tap Start to play again.`);
          }
        }
      }
    }

    function draw() {
      ctx.clearRect(0, 0, W, H);

      // Subtle grid
      ctx.globalAlpha = 0.18;
      ctx.strokeStyle = "#9aa0ff";
      for (let i = 0; i <= 12; i++) {
        const p = (i * W) / 12;
        ctx.beginPath();
        ctx.moveTo(p, 0);
        ctx.lineTo(p, H);
        ctx.stroke();
        ctx.beginPath();
        ctx.moveTo(0, p);
        ctx.lineTo(W, p);
        ctx.stroke();
      }
      ctx.globalAlpha = 1;

      // Paddle
      ctx.fillStyle = "#111";
      ctx.fillRect(paddle.x, paddle.y, paddle.w, paddle.h);

      // Blocks
      ctx.fillStyle = "#5b5bd6";
      for (const b of blocks) {
        ctx.fillRect(b.x, b.y, b.s, b.s);
      }
    }

    function loop() {
      step();
      draw();
      requestAnimationFrame(loop);
    }

    reset();
    loop();
  }

  // Auto-mount on any element with the data attribute
  function init() {
    const container = document.querySelector('[data-block-catch-widget="true"]');
    if (!container) return;
    mount(container);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
